import { z } from 'zod';
import { DateTimeSchema, objectIdRef, ObjectIdSchema, ObjectIdString } from '../common.js';
import { AccessLevel, doesUserHaveAccess, UserRole } from '../../permissions.js';

export { UserRole, AccessLevel, doesUserHaveAccess };

export const IAuthUser = z.object({
  _id: ObjectIdSchema,
  // TODO: Remove the empty-string default once name is consistently provided at user creation.
  name: z.string().default(''),
  email: z.string(),
  image: z.string().nullish(),
  role: UserRole.default('manager'),
  isInternal: z.boolean().optional(),
  testUserExpiresAt: DateTimeSchema.nullish(),
  toroAccount: objectIdRef('Account').nullish(),
  emailVerified: z.boolean().nullable().default(false),
  // Department override for StaffIQ filtering (takes precedence over BullhornUser.departmentKey)
  departmentKey: z.string().array().nullish(),

  // StaffIQ onboarding timestamp - null means user hasn't completed onboarding
  onboardedAt: DateTimeSchema.nullish(),

  createdAt: DateTimeSchema,
  updatedAt: DateTimeSchema,
});
export type IAuthUser = z.infer<typeof IAuthUser>;

export const UserDTO = z.object({
  ...IAuthUser.shape,
  _id: ObjectIdString,
  toroAccount: ObjectIdString.nullish(),
});
export type UserDTO = z.infer<typeof UserDTO>;
